import { t } from '@lingui/core/macro';
import { VStack } from '@chakra-ui/react';

import { djs } from '@duke-hq/djs';
import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { StudentEnrolmentHealth } from '@duke-hq/svc-api-db';

import buildLinkToEnrolments from '../../utils/buildLinkToEnrolments';
import ContentContainer from './shared/ContentContainer';
import ProgressBarCard from './shared/ProgressBarCard';
import SidePanelContentHeader from './shared/ContentHeader';
import NoDataMessage from './shared/NoDataMessage';

import PieFiftyToSeventyFive from './icons/PieFiftyToSeventyFive';
import PieZeroToTwentyFive from './icons/PieZeroToTwentyFive';
import PieTwentyFiveToFifty from './icons/PieTwentyFiveToFifty';
import PieSeventyFivePlus from './icons/PieSeventyFivePlus';

function PastDueWithData() {
  const { filters } = useFiltersContext();
  const { data } = trpcTenant.dashboard.getPastDue.useQuery({ filters }, { suspense: true });

  if (data === undefined) {
    return <NoDataMessage />;
  }

  const { dueLastFortnight, duePastLastFortnight } = data;
  const icons = [
    <PieZeroToTwentyFive key={0} />,
    <PieTwentyFiveToFifty key={1} />,
    <PieFiftyToSeventyFive key={2} />,
    <PieSeventyFivePlus key={3} />,
  ];

  return (
    <>
      <SidePanelContentHeader
        title={t`Semester Progress`}
        tooltipText={t`Semester progress of enrolments that are past due`}
        to={buildLinkToEnrolments({
          dueDateEnd: djs.utc(),
          health: [
            StudentEnrolmentHealth.BEHIND,
            StudentEnrolmentHealth.SLIPPING,
            StudentEnrolmentHealth.NOT_STARTED,
            StudentEnrolmentHealth.ON_TRACK,
          ],
        })}
      />

      <VStack spacing={2} align="flex-start">
        <ProgressBarCard
          title={t`Due last 14 days`}
          total={dueLastFortnight.total}
          data={dueLastFortnight.data}
          icons={icons}
          to={buildLinkToEnrolments({
            dueDateStart: djs.utc().subtract(14, 'days'),
            dueDateEnd: djs.utc(),
            health: [
              StudentEnrolmentHealth.BEHIND,
              StudentEnrolmentHealth.SLIPPING,
              StudentEnrolmentHealth.NOT_STARTED,
              StudentEnrolmentHealth.ON_TRACK,
            ],
          })}
        />

        <ProgressBarCard
          title={t`14+ days past due`}
          total={duePastLastFortnight.total}
          data={duePastLastFortnight.data}
          icons={icons}
          to={buildLinkToEnrolments({
            dueDateEnd: djs.utc().subtract(15, 'days'),
            health: [
              StudentEnrolmentHealth.BEHIND,
              StudentEnrolmentHealth.SLIPPING,
              StudentEnrolmentHealth.NOT_STARTED,
              StudentEnrolmentHealth.ON_TRACK,
            ],
          })}
        />
      </VStack>
    </>
  );
}

export default function PastDue() {
  return (
    <ContentContainer title={t`Past due`}>
      <PastDueWithData />
    </ContentContainer>
  );
}
